<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-layout row wrap v-else>
            <v-flex xs12>
                <h2>{{ $store.getters.language.data.invoices.report_title }}</h2>
                            <v-divider class="my-1"></v-divider>

            </v-flex>
            <v-flex xs12>
                <h3 class="my-1"> {{ $store.getters.language.data.invoices.invoice_profit_percentage }}: {{ (total.total_profit_price).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </h3>
                <h3 class="my-1"> {{ $store.getters.language.data.invoices.total_root_price }}: {{ (total.total_root_price).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </h3>
                <h3 class="my-1"> {{ $store.getters.language.data.invoices.total_invoice }}: {{ (total.total_invoice_price).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </h3>
            </v-flex>
            <v-flex xs12>
                <table style="width: 100%;" class="text-center">
                    <thead>
                        <tr>
                            <th class="py-1"> # </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.invoice_id }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.invoice_date }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.customer_name }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.invoice_profit }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.total_root_price }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.total_invoice }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.invoices.invoice_profit_percentage }} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in rows" :key="item.invoice_id">
                            <td> {{ index + 1 }} </td>
                            <td>
                                <a @click.prevent="openInvoice(item.invoice_id)"> {{ item.invoice_id }} </a>
                            </td>
                            <td> {{ new Date(item.invoice_date).toISOString().split('T')[0] }} </td>
                            <td> {{ item.customer_name }} </td>
                            <td> {{ item.invoice_profit_percentage}}% </td>
                            <td> {{ ((item.root_price || 0).toLocaleString()) }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                            <td> {{ (item.total_invoice || 0).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                            <td> {{ ((item.profit_price || 0).toLocaleString()) }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                        </tr>
                    </tbody>
                </table>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import requests from '../../../requests/reports.request'
export default {
    props: {
        query: Object
    },
    data() {
        return {
            rows: [],
            loading: true,
            total: {}
        }
    },
    mounted() {
        var q = 'store_id=' + this.$store.getters.store.store_id;
        const arr = Object.entries(this.query);

        if(arr.length > 0) {
            for(var item of arr) {
                if(item[1] && item[1] != "null" && item != '') {
                    q += '&' + item[0] + '=' + item[1];
                }
            }
        }
        requests.invoicesReport(q).then(r => {
            this.rows = r.data.rows;
            this.total = r.data.total;
            this.loading = false;
        })
    },
    methods: {
        openInvoice(id) {
            window.open(`/pos/${id}`, '_blank')
        },
    }
}
</script>

<style scoped>
    table {
        border: 1px solid;
        border-collapse: collapse;
    }
    tr {
        border: 1px solid;
    }
    td, th {
        border: 1px solid;
    }
</style>
